import { Link } from "react-router-dom";
import type { Special } from "@/types/content";

export default function SpecialBanner({ special }: { special: Special }) {
  return (
    <section className="relative rounded-lg overflow-hidden">
      <img
        src={special.cover}
        alt={special.title}
        title={`${special.title} - 影视主题专题`}
        className="w-full h-64 md:h-72 object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-transparent"></div>
      <div className="absolute inset-0 px-6 md:px-10 flex flex-col justify-center max-w-2xl">
        <span className="inline-flex w-fit items-center gap-1.5 px-2.5 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-bold mb-3">
          <i className="ri-fire-line"></i>
          本期专题
        </span>
        <h3 className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{special.title}</h3>
        <p className="mt-2 text-sm text-background-300 line-clamp-2">{special.subtitle}</p>
        <Link
          to="/special"
          className="mt-4 inline-flex w-fit items-center gap-1.5 px-5 py-2.5 rounded-md bg-background-50 text-primary-800 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
        >
          查看专题
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}